import { IFormChecklistItem } from "../types";

/**
 * Orders checklist items so actionable (unblocked, not-yet-completed) forms come
 * first, then completed forms, then anything still blocked by a prerequisite.
 * `IFormChecklistItem` no longer carries `optional`, so ordering is purely by
 * `blockedBy` / `status`.
 */
const rank = (item: IFormChecklistItem): number => {
  if (item.blockedBy.length > 0 || item.status === "Locked") return 2;
  if (item.status === "Completed") return 1;
  return 0;
};

export const selectorChecklistOrder = (
  items: IFormChecklistItem[]
): IFormChecklistItem[] => [...items].sort((a, b) => rank(a) - rank(b));
